<template>
    <v-card>
        <v-card-title>
            <h4 class="font-weight-600">Advance Filter</h4>
            <v-spacer />
            <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pb-5 pt-8">
            <v-row>
                <v-col cols="5">
                    <div>
                        <div class="font-weight-500">Filter</div>
                        <div class="mt-1">
                            <v-autocomplete
                                v-model="form_filter"
                                :items="filter_data"
                                item-value="id"
                                item-text="text"
                                dense
                                placeholder="Pilih Filter"
                                outlined
                            />
                        </div>
                    </div>
                </v-col>
                <v-col cols="5">
                    <div>
                        <div class="font-weight-500">Value</div>
                        <div class="mt-1">
                            <template v-if="form_filter === 'is_pembahasan'">
                                <v-radio-group
                                    v-model="form_value"
                                    row
                                    dense
                                    class="py-0 mt-0"
                                >
                                    <v-radio label="Ada" value="true"></v-radio>
                                    <v-radio
                                        label="Tidak Ada"
                                        value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </template>

                            <v-text-field
                                v-else
                                v-model="form_value"
                                placeholder="Isi Pencarian"
                                dense
                                outlined
                                @keyup.enter="addSelectedFilter()"
                            />
                        </div>
                    </div>
                </v-col>
                <v-col cols="2">
                    <div style="margin-top: 27px">
                        <v-btn
                            color="blew"
                            :max-height="45"
                            depressed
                            dark
                            @click="addSelectedFilter()"
                        >
                            Add Filter
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <div class="pt-2">
                <v-chip
                    v-for="(data, i) in filter_selected"
                    :key="i"
                    close
                    color="#f3f5f7"
                    class="mb-3 mr-1 custom-chip-close"
                    @click:close="removeFilter(i, data)"
                >
                    {{ data.filter_name }} :

                    <span v-if="data.filter === 'is_pembahasan'">
                        {{ data.value === "true" ? "Ada" : "Tidak Ada" }}
                    </span>

                    <span v-else>
                        {{ data.value }}
                    </span>
                </v-chip>
            </div>
        </v-card-text>

        <v-card-actions class="mt-5 pb-7">
            <v-row>
                <v-col cols="6">
                    <v-btn
                        color="touchBlue"
                        class="blew--text"
                        rounded
                        depressed
                        block
                        @click="$emit('close')"
                    >
                        Batal
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn
                        color="blew"
                        class="white--text"
                        rounded
                        depressed
                        block
                        :disabled="!filter_selected.length"
                        @click="onFilter()"
                    >
                        Terapkan
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null },
        subtitle: { type: String, default: null },
    },
    data: function () {
        return {
            form_filter: "",
            form_value: "",
            filter_data: [
                {
                    id: "is_pembahasan",
                    text: "Ketersediaan Pembahasan",
                    order: 1,
                },
                {
                    id: "mapel_name",
                    text: "Mapel",
                    order: 2,
                },
                {
                    id: "item_code",
                    text: "Kode Soal",
                    order: 3,
                },
                {
                    id: "bab",
                    text: "Bab",
                    order: 4,
                },
                {
                    id: "subbab",
                    text: "Sub Bab",
                    order: 5,
                },
                {
                    id: "subsubbab",
                    text: "Sub Sub Bab",
                    order: 6,
                },
                {
                    id: "is_valid",
                    text: "Validasi Soal",
                    order: 7,
                },
                {
                    id: "is_new",
                    text: "Soal Terbaru",
                    order: 8,
                },
                {
                    id: "jenjang",
                    text: "Jenjang",
                    order: 9,
                },
                {
                    id: "grade",
                    text: "Kelas",
                    order: 10,
                },
                {
                    id: "jenis",
                    text: "Jenis",
                    order: 11,
                },
                {
                    id: "difficulty_level",
                    text: "Tingkat Kesulitan",
                    order: 12,
                },
                {
                    id: "tipe_pilihan",
                    text: "Tipe Pilihan",
                    order: 13,
                },
                {
                    id: "label",
                    text: "Label",
                    order: 14,
                },
                {
                    id: "nilai_eigen",
                    text: "Eigen",
                    order: 15,
                },
                {
                    id: "eigen_comparison",
                    text: "Eigen Perbandingan",
                    order: 16,
                },
            ],
            filter_selected: [],
        };
    },

    methods: {
        addSelectedFilter() {
            if (!this.form_filter || !this.form_value) {
                return false;
            }

            var newFilter = {
                filter: this.form_filter,
                filter_name: this.getObjFieldText(this.form_filter),
                order: this.getObjFieldOrder(this.form_filter),
                value: this.form_value,
            };

            // this.filter_data = this.filter_data.filter(
            //     (item) => item.id !== this.form_filter
            // );

            const index = this.filter_selected.findIndex(
                (item) => item.filter === newFilter.filter
            );

            if (index !== -1) {
                this.filter_selected[index] = newFilter;
            } else {
                this.filter_selected.push(newFilter);
            }

            this.form_filter = "";
            this.form_value = "";
        },

        removeFilter(index, data) {
            this.filter_selected.splice(index, 1);

            this.filter_data.push({
                id: data.filter,
                text: data.filter_name,
                order: data.order,
            });

            this.filter_data = this.filter_data.sort(
                (a, b) => a.order - b.order
            );
        },

        getObjFieldText(id) {
            var text = this.filter_data.find((e) => e.id === id).text;
            return text;
        },

        getObjFieldOrder(id) {
            var order = this.filter_data.find((e) => e.id === id).order;
            return order;
        },

        onFilter() {
            this.$emit("filter", this.filter_selected);
        },
    },
};
</script>

<style>
.sm-form .v-input__slot {
    min-height: 47px !important;
    font-size: 14px !important;
}

.sm-dropdown .v-input__control .v-input__slot {
    min-height: 47px !important;
    max-height: 47px !important;
    font-size: 14px !important;
}

.custom-chip-close .v-chip__close {
    color: #eb5757 !important;
}
</style>



// WEBPACK FOOTER //
// DialogAdvanceFilter.vue?c01b026e